import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "sonner";
import Inquire from "./pages/Inquire";
import Login from "./pages/Login";
import AdminLayout from "./pages/AdminLayout";
import Dashboard from "./pages/Dashboard";
import Pipeline from "./pages/Pipeline";
import CalendarPage from "./pages/CalendarPage";
import ProjectDetail from "./pages/ProjectDetail";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="h-screen flex items-center justify-center text-white/50 font-mono text-sm">Loading…</div>;
  if (!user || user.role !== "admin") {
    return <Navigate to="/admin/login" replace state={{ from: loc }} />;
  }
  return children;
};

function App() {
  useEffect(() => { document.documentElement.classList.add("dark"); }, []);
  return (
    <div className="grain min-h-screen bg-[#050505] text-[#F4F4F0]">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public default: client intake wizard */}
            <Route path="/" element={<Inquire />} />

            {/* Admin */}
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
              <Route index element={<Navigate to="pipeline" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="pipeline" element={<Pipeline />} />
              <Route path="calendar" element={<CalendarPage />} />
              <Route path="projects/:id" element={<ProjectDetail />} />
            </Route>

            {/* Legacy redirects */}
            <Route path="/login" element={<Navigate to="/admin/login" replace />} />
            <Route path="/inquire" element={<Navigate to="/" replace />} />
            <Route path="/app/*" element={<Navigate to="/admin" replace />} />
            <Route path="/dashboard" element={<Navigate to="/admin" replace />} />
            <Route path="/portal" element={<Navigate to="/" replace />} />
            <Route path="/portal/*" element={<Navigate to="/" replace />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
